interface DocumentRequestEmailContentProps {
	additionalMessage: string;
	adminName: string;
	documentCategory: string;
	projectName: string;
	requesterName: string;
	rfxName: string;
	rfxType: string;
}

const cellStyle = {
	fontFamily: "Arial, sans-serif",
	fontSize: "16px",
	lineHeight: "24px",
	color: "#374151",
	paddingBottom: "20px",
} as const;

const DocumentRequestEmailContent: React.FC<DocumentRequestEmailContentProps> = ({
	adminName,
	requesterName,
	rfxName,
	rfxType,
	projectName,
	documentCategory,
	additionalMessage,
}) => {
	return (
		<table
			width="100%"
			style={{ backgroundColor: "#ffffff" }}
		>
			<tbody>
				<tr>
					<td align="center">
						<table
							width="600"
							style={{ maxWidth: "600px" }}
						>
							<tbody>
								<tr>
									<td
										style={{
											...cellStyle,
											paddingTop: "40px",
											color: "#1F2937",
											paddingBottom: "24px",
										}}
									>
										Hi {adminName || "[Admin Name]"},
									</td>
								</tr>
								<tr>
									<td style={cellStyle}>
										<strong>{requesterName || "[Requester]"}</strong> has
										requested that a corporate document be uploaded to your
										company profile to support their response to an{" "}
										{rfxType || "RFx"}.
									</td>
								</tr>
								<tr>
									<td style={cellStyle}>
										<strong>{rfxType || "RFx"}:</strong>{" "}
										{rfxName || "[RFx Name]"}
									</td>
								</tr>
								<tr>
									<td style={cellStyle}>
										<strong>Project:</strong>{" "}
										{projectName || "[Project Name]"}
									</td>
								</tr>
								<tr>
									<td style={cellStyle}>
										<strong>Document category needed:</strong>{" "}
										{documentCategory || "[Category]"}
									</td>
								</tr>
								{additionalMessage ? (
									<>
										<tr>
											<td style={{ ...cellStyle, paddingBottom: "8px" }}>
												<strong>
													Additional note from{" "}
													{requesterName || "[Requester]"}:
												</strong>
											</td>
										</tr>
										<tr>
											<td
												style={{
													...cellStyle,
													backgroundColor: "#F9FAFB",
													padding: "12px 16px",
													borderLeft: "4px solid #3B82F6",
													borderRadius: "4px",
												}}
											>
												{additionalMessage}
											</td>
										</tr>
									</>
								) : null}
								<tr>
									<td style={cellStyle}>
										Please upload the required document to your company
										profile so it can be included in the {rfxType || "RFx"}{" "}
										response.
									</td>
								</tr>
								<tr>
									<td style={{ paddingBottom: "20px", textAlign: "center" as const }}>
										<a
											href="#"
											style={{
												display: "inline-block",
												padding: "12px 24px",
												fontFamily: "Arial, sans-serif",
												fontSize: "16px",
												color: "#ffffff",
												textDecoration: "none",
												fontWeight: "bold",
												backgroundColor: "#263859",
												borderRadius: "6px",
											}}
										>
											Go to Company Profile
										</a>
									</td>
								</tr>
								<tr>
									<td style={cellStyle}>
										<br />
										Best Regards,
										<br />
										<br />
										<strong>The Procuracon Team</strong>
										<br />
										<em>
											Supporting transparent and efficient procurement
										</em>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
	);
};

export { DocumentRequestEmailContent };
